import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png";
import styles from "./ConfirmationPop.module.scss";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { useCreateNoteMutation, useUpdateNoteMutation } from "store/services/V2/notes";
import { userFullName, successMessageToast } from "helpers/common";
import { useParams } from "react-router-dom";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { User } from "react-feather";
import LoadingButton from "components/shared/LoadingButton";
import { useLazyTherapistLookupQuery } from "store/services/utility";
import { debounce } from "lodash";
import { RequiredFieldAstrick } from "components/Common/Common";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import addAttendanceSchema from "./updateExpirySchema.schema";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { ATTENDANCE_OPTIONS, STAFF_TASK_TYPE_OPTIONS } from "config/constants";
import { useAddAttendanceMutation } from "store/services/attendance";
import { useUpdateClientExpiryMutation } from "store/services/client";
import updateExpirySchema from "./updateExpirySchema.schema";


const ClientExpiryModal = ({
  onCancel,
  show,
  setShow,
  caseLoadId,
  refetch,
  clientId,
  clientType,
  clientDetails
}) => {

  const handleClose = () => {
    setShow(false);
  };

  const handlePopup = () => setShow(!show);
  const [initialValues, setInitialValues] = useState({ date_of_expiry: null, activeFrom: null })

  const [updateExpiry, { isLoading: updateExpiryLoading }] = useUpdateClientExpiryMutation()

  const handleSubmit = async (values) => {

    try {

      // setShow(false);
      const data = {
        date_of_expiry: values?.date_of_expiry
      }
      const result = await updateExpiry({ clientId, clientType, data }).unwrap();
      if (!result.error) {
        successMessageToast(result?.message);
        handlePopup()
        refetch();
      }

    } catch (err) { console.log("error adding attendance", err); };
  };

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  useEffect(() => {
    if (clientDetails) {
      setInitialValues((prev) => ({ ...prev, date_of_expiry: clientDetails?.client_detail?.date_of_expiry, activeFrom: clientDetails?.client_detail?.createdAt }))
    }
  }, [clientDetails])

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal modal-v2`}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      centered
      size="sm"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="text-center mx-auto">
          {/* Header */}
          <div
            className="section-title d-flex align-items-center justify-content-between"
            style={{ borderBottom: "1px solid #315D99" }}
          >
            <h3 className="mb-0 pb-0 section-title border-bottom-0" style={{ fontSize: "14px" }}>
              MANAGE ACCOUNT STATUS
            </h3>
            <img
              onClick={handleClose}
              width={16}
              height={16}
              src={crossIcon}
              alt="crossIcon"
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Formik Form */}
          <Formik
            initialValues={initialValues}
            validationSchema={updateExpirySchema}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              values
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row >
                  <Col md="6" sm="6" className="my-3  text-start  name-input-v2">
                    <label
                      htmlFor=""
                      className="discharge-screen-label mt-0"
                    >
                      Active From
                    </label>
                    <AppDatePicker
                      name="activeFrom"
                      placeholder="e.g John"
                      className={`${styles.formControl} readonly-box h-auto`}
                      maxLength={30}
                      disabled
                      portalId={"root"}
                      autocomplete="off"
                    />
                  </Col>
                  <Col md="6" sm="6" className="my-3  text-start  name-input-v2">
                    <label
                      htmlFor=""
                      className="discharge-screen-label mt-0"
                    >
                      To (Date of Expiry )
                    </label>
                    <AppDatePicker
                      name="date_of_expiry"
                      placeholder="e.g John"
                      className={`${styles.formControl} readonly-box h-auto`}
                      maxLength={30}
                      portalId={"root"}
                      autocomplete="off"
                      minDate={tomorrow}
                    />
                  </Col>
                  <Col md="12" sm="6" className="">
                    <p className="text-muted text-start mb-0" style={{ color: '#8F8F8F' }}><span className="fw-medium proxima-regular">NOTE:</span> Account status will automatically change to <span className="proxima-regular fw-medium" style={{ color: '#8F8F8F' }}> INACTIVE </span> on the date of expiry</p>
                    {/* <div class="main-attendance-fields">
                      <div class="inner-attendance-fields">
                        <label class="present-absent">Present
                          <input
                            type="radio"
                            checked={values.attendance == "present"}
                            name="attendance"
                            value={"present"}
                            onChange={handleChange}
                          />
                          <span class="checkmark"></span>
                        </label>
                        <label class="present-absent">Absent
                          <input
                            type="radio"
                            name="attendance"
                            value={"absent"}
                            checked={values.attendance == "absent"}
                            onChange={handleChange}
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div> */}
                  </Col>
                </Row>
                <div className="d-flex justify-content-end mt-4 gap-2">
                  <button
                    className="blue-discharge-screen-btn-border"
                    variant="secondary"
                    onClick={handleClose}
                    disabled={updateExpiryLoading}
                  >
                    Cancel
                  </button>

                  <LoadingButton
                    type="submit"
                    className="blue-discharge-screen-btn"
                    // style={{
                    //   backgroundColor: "#93278F",
                    //   border: "none",
                    //   borderRadius: "0",
                    //   padding: "6px 16px",
                    // }}
                    isLoading={updateExpiryLoading}
                  >
                    Save
                  </LoadingButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ClientExpiryModal;
